<template>
  <div class="pc-history">
    <h1 class="pc-history-head">访问页面</h1>
    <el-date-picker
      class="date-picker"
      v-model="userActArgs.date"
      type="datetime"
      placeholder="选择日期时间"
      align="right"
      :picker-options="pickerOptions"
      @change='dateChange'
    >
    </el-date-picker>

    <div class="pc-history-body">
      <div class="body-list">
        <el-steps direction="vertical" class="body-list-left">
          <el-step
            v-for="item in userTrack"
            :key="item.index"
            :title="item.request_date"
            :description="'工具人'"
          >
          </el-step>
        </el-steps>

        <el-steps direction="vertical" class="body-list-right">
          <el-step
            v-for="item in userTrack"
            :key="item.index"
            :title="'访问页面:' +item.page_router"
            :description="'--设备:'+item.driver + ' --操作系统:'+item.os +  ' --浏览器:'+item.browser + '  --位置:' + item.country +'/' + item.province + '/' +item.city + ' --经度:' + item.lat + ' --纬度: ' + item.lng + ' --ip地址:' + item.ip_address
            "
          >
          </el-step>
        </el-steps>
      </div>
    
      <p class="body-end" v-if="userTrack.length!=0">访问结束</p>
      <p class="body-end" v-else>今日无访问</p>
    </div>
  </div>
</template>



<script>
import { getUserAct_Api } from "../../../../apis/user.api";
export default {
  props: ["data"],

  data() {
    return {
      userActArgs: {
        user_id: null,
        date: null,
      },
      userTrack: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
    };
  },
  created() {
    this.userActArgs.date = this.$dtime(new Date()).format("YYYY-MM-DD")
    this.getUserAct();
  },
  methods: {
    dateChange(data){
      if(data){
        this.userActArgs.date = this.$dtime(data).format("YYYY-MM-DD")
        this.getUserAct()
      }
    },
    getUserAct() {
      this.userActArgs.user_id = this.$route.query.id;
      getUserAct_Api(this.userActArgs).then((res) => {
        console.log(res);
        this.userTrack = res.data
      });
    },
  },
};
</script>



<style lang="scss" scoped>
.pc-history {

  padding: 30px 30px 0 30px;
  height: 440px;
  border-radius: 4px;
  box-shadow: $shadowCard;
  position: relative;
  .pc-history-head {
    padding-bottom: 15px;
    border-bottom: 1px solid $border-color;
    font-family: $chinese;
    font-size: 20px;
    font-weight: 600;
    color: $mainTitle;
  }
  .date-picker{
    position:absolute;
    top:20px;
    right:200px;
  }

  // 滚轴
  .pc-history-body::-webkit-scrollbar-thumb:hover {
    background-color: $secondTitle;
  }
  .pc-history-body::-webkit-scrollbar-thumb {
    background-clip: content-box !important;
    border-left: 2px solid transparent;
    border-right: 2.5px solid transparent;
    border-top: 3px solid transparent;
    border-bottom: 3px solid transparent;
    border-radius: 100px;
    background-color: $lightenGreya;
  }
  .pc-history-body::-webkit-scrollbar-button {
    display: none;
  }
  .pc-history-body::-webkit-scrollbar {
    width: 14px;
    border: $bordertabled;
  }
  // end 滚轴
  .pc-history-body {
    margin-top: 20px;
    padding-left: 40px;
    overflow-y: auto;
    padding-top: 10px;
    height: 320px;
    .body-list {
      display: flex;
      /deep/ .el-step__icon-inner {
        display: none !important;
      }
      /deep/ .el-step__icon {
        transform: translateY(-2px);
        margin-left: 5.5px;
        width: 13px;
        height: 13px;
        border: 2px solid white;
        background: $blueBtna;
      }
      /deep/ .el-step__head,
      /deep/ .el-step__main {
        min-height: 65px;
      }
      .body-list-left {
        /deep/ .el-step__description {
          visibility: hidden;
        }
        /deep/ .el-step__head {
          display: none;
        }
        /deep/ .el-step__title {
          transform: translateY(-7px);
          margin-right: 40px;
          font-size: 14px;
          font-family: $chinese;
          color: $secondTitle;
        }
      }
      .body-list-right {
        /deep/ .el-step__main {
          transform: translateY(-4px);
          padding-left: 40px;
        }
        /deep/ .el-step__title {
          font-size: 14px;
          font-family: $chinese;
          color: $mainTitle;
        }
        /deep/ .el-step__description {
          transform: translateY(-2px);
          padding-right:0px;
          font-size: 10px;
          font-family: $chinese;
          color: $timeBtn;
        }
      }
    }
    .body-end {

      padding-left: 10px;
      font-family: $chinese;
      font-size: 16px;
      font-weight: 800;
      color: $secondTitle;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/userManagement/userDetail/WebHistory.vue